import React, { useEffect } from 'react'
import { loadScript, loadCSS } from './../../Utils/Misc'

// If this component is loaded we need to load it's required scripts only once
// Load external scripts
const scriptsLoader = {
  listeners_: [],
  done: function(listener) {
    if (this.loaded) return listener()
    this.listeners_.push(listener)
  },
  loaded: false,
}

Promise.all(
  [
    'https://cdnjs.cloudflare.com/ajax/libs/jquery/1.11.2/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/PapaParse/4.1.2/papaparse.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js',
  ].map(f => loadScript(f)),
)
  .then(() => loadScript('/js/pivot.js'))
  .then(() => loadCSS('https://pivottable.js.org/dist/pivot.css'))
  .then(() => {
    scriptsLoader.loaded = true
    scriptsLoader.listeners_.forEach(l => l())
  })

const View = props => {
  useEffect(() => {
    if (!scriptsLoader.loaded) return
    scriptsLoader.done(
      () =>
        /* eslint-disable */
        $(function() {
          $('#output').pivotUI(props.missions)
        }),
      /* eslint-enable */
    )
  })
  if (scriptsLoader.loaded) return <div id="output" style={{ margin: 30 }} />
  return <div>PIVOT TABLES</div>
}

export default View
